import React from 'react';
import { icons, iconViewBoxes } from './iconPaths';
import { IconProps } from './icon.types';
import * as S from './icon.styles';

/**
 * Icon component that renders SVG icons from our design system
 */
export const Icon: React.FC<IconProps> = ({ name, color, size = 32, className = '', title, style, ...props }) => {
  if (!icons[name]) {
    return null;
  }

  const viewBox = iconViewBoxes?.[name] || '0 0 32 32';
  const iconPath = icons[name] as string | string[];

  return (
    <S.Icon
      data-testid={`icon-${name}`}
      width={size}
      height={size}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      fillColor={color}
      className={className}
      style={style}
      {...props}
    >
      {title && <title>{title}</title>}
      {Array.isArray(iconPath) ? (
        iconPath.map((path: string, index: number) => <path key={index} d={path} />)
      ) : (
        <path d={iconPath} />
      )}
    </S.Icon>
  );
};
